<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/messages/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  data() {
    return {
      formRoute: route('api.v1.knowledge_base.messages.store'),
      redirectRoute: route('knowledge_base.messages.index'),
      stayOnPageRedirect: route('knowledge_base.messages.edit', {message: '_id_'}),
    }
  },
}
</script>

<template>
  <App title="Bericht toevoegen">
    <form id="messageForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="messageForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>